// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"RK-z","carouselContainer":"SK-z"};